const config = {
  serverUrl: process.env.REACT_APP_PRESENTATION_SERVER || 'http://localhost:5001',
  clientUrl: process.env.REACT_APP_CLIENT_URL || 'http://localhost:3000',
  isProduction: process.env.NODE_ENV === 'production'
};

// Detectar ambiente baseado na URL atual
if (typeof window !== 'undefined') {
  const hostname = window.location.hostname;
  const port = window.location.port;
  const protocol = window.location.protocol;
  
  // Se estiver em localhost
  if (hostname === 'localhost' || hostname === '127.0.0.1') {
    config.serverUrl = 'http://localhost:5001'; // Corrigido: era 5000, agora é 5001
    config.clientUrl = `http://localhost:${port || '3000'}`;
    config.isProduction = false;
  } else if (hostname.includes('link2.do') || hostname.includes('')) {
    config.serverUrl = 'https://link2do-presentation-686b363c7e57.herokuapp.com';
    config.clientUrl = 'https://link2.do';
    config.isProduction = true;
  }
  // Qualquer outro domínio
  else {
    config.clientUrl = `${protocol}//${hostname}${port ? ':' + port : ''}`;
  }
}

// Log de debug
console.log('🔧 Configuração:', {
  serverUrl: config.serverUrl,
  clientUrl: config.clientUrl,
  isProduction: config.isProduction,
  ambiente: config.isProduction ? 'Produção' : 'Desenvolvimento'
});

export default config;